import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

interface AttachOrphanContactsPayload {
  company_id: string;
  /** Member whose orphan contacts are put back */
  owner_uid: string;
  /** Number they join: its holder becomes their owner */
  subscription_id: string;
}

/**
 * Puts the orphan contacts of a member on a company number, with their history. Supervisor only.
 * Resolves with the number of contacts put back.
 */
export async function attachOrphanContacts(
  payload: AttachOrphanContactsPayload,
  auth: Authentication,
): Promise<number> {
  try {
    const response = await HttpClient.post('/company/contacts/orphans/attach', payload, auth.token);

    return response.data?.attached ?? 0;
  } catch (e) {
    console.error('attachOrphanContacts error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new AttachOrphanContactsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new AttachOrphanContactsFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class AttachOrphanContactsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}